export interface AllowedLanguage {
  code: string;
  name: string;
}

export const Config = {
  APP_BASE: process.env.BASE_URL!,
  HUB_API_BASE: process.env.VUE_APP_API_BASE!,
  IMAGE_BASE: process.env.VUE_APP_IMAGE_BASE!,
  DEFAULT_LANGUAGE: process.env.VUE_APP_DEFAULT_LANG!,
  FALLBACK_LANGUAGE: process.env.VUE_APP_FALLBACK_LANG!,
  APP_VERSION: process.env.VUE_APP_VERSION!,
  RECAPTCHA_SITE_KEY: process.env.VUE_APP_RECAPTCHA_SITE_KEY!,
  GTM_CONTAINER_ID: process.env.VUE_APP_GTM_CONTAINER_ID!,
  GA4_ID: process.env.VUE_APP_GA4_ID!,
  LANGUAGES: process.env.VUE_APP_LANGUAGES!
    .split(',')
    .map((raw: string) => raw.split('=', 2))
    .map((parts: string[]) => ({code: parts[0], name: parts[1] ?? parts[0]})),
};
